import React, { useState } from 'react';
import { ConfigProvider, Pagination } from 'antd';
import viVN from 'antd/locale/vi_VN';
import { formatNumber } from '../../../../services/mixin';
import '../styles.scss';
import { dataPagination } from '../../../../until';
import { IReportVoucherByCampaign } from '../../../../api/reportCustomer/reportCustomerApi';

export interface IVoucherCampaignItem {
    id: number | string;
    campaignName: string;
    voucherName: string;
    voucherTypeGroup: string;
    voucherType: string;
    issuedQuantity: number;
    convertedQuantity: number;
    convertedRate: number;
}

interface Props {
    data: IReportVoucherByCampaign[] | undefined;
    totalReportVoucherByCampaign: {
        totalIssued: number;
        totalRedeemed: number;
        rateRedeemed: number;
    } | undefined
    pagination?: {
        current: number;
        pageSize: number;
        total: number;
    }
    onPaginationChange: (page: number, pageSize: number) => void
}

const DEFAULT_MOCK_DATA: IVoucherCampaignItem[] = [
    {
        id: 1,
        campaignName: 'Ưu đãi xe cho phái đẹp',
        voucherName: 'Voucher phái đẹp',
        voucherTypeGroup: 'Voucher công khai',
        voucherType: 'Giảm giá trực tiếp',
        issuedQuantity: 2000,
        convertedQuantity: 0,
        convertedRate: 0,
    },
    {
        id: 2,
        campaignName: 'Đăng ký lái thử xe Peugeot',
        voucherName: 'Voucher đăng ký lái thử',
        voucherTypeGroup: 'Voucher nhóm',
        voucherType: 'Tặng sản phẩm/dịch vụ',
        issuedQuantity: 2000,
        convertedQuantity: 1500,
        convertedRate: 1500,
    },
    {
        id: 3,
        campaignName: 'Sinh nhật',
        voucherName: 'Voucher sinh nhật',
        voucherTypeGroup: 'Voucher cá nhân',
        voucherType: 'Mua sản phẩm/ dịch vụ ưu đãi',
        issuedQuantity: 2000,
        convertedQuantity: 100,
        convertedRate: 100,
    },
    {
        id: 4,
        campaignName: 'Ngày thành lập',
        voucherName: 'Voucher ngày thành lập',
        voucherTypeGroup: 'Voucher công khai',
        voucherType: 'Khác',
        issuedQuantity: 2000,
        convertedQuantity: 1000,
        convertedRate: 1000,
    },
    {
        id: 5,
        campaignName: 'Ưu đãi xe cho phái đẹp',
        voucherName: 'Voucher phái đẹp',
        voucherTypeGroup: 'Voucher nhóm',
        voucherType: 'Giảm giá trực tiếp',
        issuedQuantity: 2000,
        convertedQuantity: 0,
        convertedRate: 0,
    },
    {
        id: 6,
        campaignName: 'Đăng ký lái thử xe Peugeot',
        voucherName: 'Voucher đăng ký lái thử',
        voucherTypeGroup: 'Voucher cá nhân',
        voucherType: 'Tặng sản phẩm/dịch vụ',
        issuedQuantity: 2000,
        convertedQuantity: 1500,
        convertedRate: 1500,
    },
    {
        id: 7,
        campaignName: 'Sinh nhật',
        voucherName: 'Voucher sinh nhật',
        voucherTypeGroup: 'Voucher công khai',
        voucherType: 'Mua sản phẩm/ dịch vụ ưu đãi',
        issuedQuantity: 2000,
        convertedQuantity: 100,
        convertedRate: 100,
    },
    {
        id: 8,
        campaignName: 'Ngày thành lập',
        voucherName: 'Voucher ngày thành lập',
        voucherTypeGroup: 'Voucher nhóm',
        voucherType: 'Khác',
        issuedQuantity: 2000,
        convertedQuantity: 1000,
        convertedRate: 1000,
    },
];

const VoucherCampaignReportTable: React.FC<Props> = ({
    data,
    totalReportVoucherByCampaign,
    pagination,
    onPaginationChange
}) => {


    return (
        <div className="pt-4 w-full">
            <div className="">
                <span className="text-base font-medium text-344054">
                    Báo cáo voucher theo chiến dịch
                </span>
            </div>

            <div className="ct-wrapper">
                <div className="ct-table-scroll">
                    <table className="ct-table w-full">
                        <thead>
                            <tr className="ct-thead-row1">
                                <th style={{ textAlign: 'left', width: '22%' }}>Tên chiến dịch</th>
                                <th style={{ textAlign: 'left', width: '18%' }}>Tên voucher</th>
                                <th style={{ textAlign: 'left', width: '16%' }}>Loại hình voucher</th>
                                <th style={{ textAlign: 'left', width: '20%' }}>Loại voucher</th>
                                <th style={{ textAlign: 'right', width: '10%' }}>Số phát hành</th>
                                <th style={{ textAlign: 'right', width: '8%' }}>Số quy đổi</th>
                                <th style={{ textAlign: 'right', width: '6%' }}>% quy đổi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Dòng Tổng cộng */}
                            <tr className="ct-total-row">
                                <td className="ct-total-name">TỔNG CỘNG</td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td style={{ textAlign: 'right' }}>{formatNumber(totalReportVoucherByCampaign?.totalIssued ?? 0)}</td>
                                <td style={{ textAlign: 'right' }}>{formatNumber(totalReportVoucherByCampaign?.totalRedeemed ?? 0)}</td>
                                <td style={{ textAlign: 'right' }}>{totalReportVoucherByCampaign?.rateRedeemed}</td>
                            </tr>

                            {/* Dữ liệu các dòng */}
                            {data?.map((item, index) => (
                                <tr key={item.id || index} className="ct-child-row">
                                    <td className="ct-td-text">{item?.campaignTitle}</td>
                                    <td className="ct-td-text">{item?.voucherTitle}</td>
                                    <td className="ct-td-text">{item?.typeName}</td>
                                    <td className="ct-td-text">{item?.typeVoucherTitle}</td>
                                    <td className="ct-td-num" style={{ textAlign: 'right' }}>
                                        {formatNumber(item?.totalIssued)}
                                    </td>
                                    <td className="ct-td-num" style={{ textAlign: 'right' }}>
                                        {formatNumber(item?.totalRedeemed)}
                                    </td>
                                    <td className="ct-td-num" style={{ textAlign: 'right' }}>
                                        {formatNumber(item?.rateRedeemed)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* Footer Phân Trang */}



            </div>
            {/* <ConfigProvider locale={viVN}>
                <div className="pagination-block flex justify-center">

                    <Pagination
                        total={totalCount}
                        current={page}
                        pageSize={pageSize}
                        showSizeChanger
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(totalCount, pageSize, page).totalPage} trang`}
                        locale={{ items_per_page: 'trang' }}
                        onChange={(p, size) => {
                            setPage(p);
                            setPageSize(size);
                        }}
                    />
                </div>
            </ConfigProvider> */}
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        className='rs-pagination'
                        showSizeChanger
                        current={pagination?.current}
                        pageSize={pagination?.pageSize}
                        total={pagination?.total}
                        pageSizeOptions={[10, 20, 50, 100]}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(pagination?.total ?? 0, pagination?.pageSize ?? 0, pagination?.current ?? 0).totalPage} trang`}
                        onChange={onPaginationChange}
                    />
                </div>
            </ConfigProvider>

            {/* <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        showSizeChanger
                        current={page}
                        pageSize={pageSize}
                        total={totalCount}
                        itemRender={(page, type, originalElement) => {
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            return originalElement;
                        }}
                        showTotal={() => `Tổng cộng ${dataPagination(totalCount, pageSize, page).totalPage} trang`}
                        className='rs-pagination'
                        onChange={(page, size) => {

                            setPage(page);

                            setPageSize(size);


                        }}
                    />
                </div>
            </ConfigProvider> */}

        </div>
    );
};

export default VoucherCampaignReportTable;
